<template>
  <div v-if="modelC && chartData">
      <b-card class="mb-4"
              style="min-width: 220px; max-width: 220px; max-height: 230px;"
              :no-body="true">
        <div class="mb-2">
          <pie-chart-wrapper :value="category + ' / '+ catKey  "
                             :setA="label[0]"
                             :setB="label[1]"
                             :input="chartData.datasets[0]['data'][0]"
                             :output="chartData.datasets[0]['data'][1]">
            <template v-slot:chart>
              <pie-chart :width="180"
                         :height="180"
                         :options="optionsC"
                         :chartData="chartData"
                         chartID="A">

              </pie-chart>
            </template>
          </pie-chart-wrapper>
        </div>

        <!--template v-slot:footer>
          <table>
            <tr>
              <td class="timelink"
                  v-for="(item, key) in timelines"
                  v-if="['live','hour','day'].includes(key)">
                <b-link @click="time =  key"
                        class="m-1"
                        :key="key">
                        {{item}}
                </b-link>
              </td>
            </tr>
            <tr>
              <td class="timelink"
                  v-for="(item, key) in timelines"
                  v-if="['week','month','year'].includes(key)">
                <b-link @click="time =  key"
                        class="m-1"
                        :key="key">
                  {{item}}
                </b-link>
              </td>
            </tr>
          </table>
          <hr>
          <table>
            <tr>
              <td>
                <b-form-radio class="mr-2" v-model="cf" name="some-radios" value="MAX" @input="getG()">Maximum</b-form-radio>
              </td>
              <td>
                <b-form-radio v-model="cf" value="AVERAGE" @input="getG()">Mittel</b-form-radio>
              </td>
            </tr>
          </table>
        </template-->
      </b-card>
  </div>
</template>

<script>
  //import {VserverGraph} from "@/store/models/vserver/vserver_graph";
  import {Vserver} from "@/store/models/vserver/vserver";
  import {ChartOptions} from "@/mixins/chart_options";
  import PieChartWrapper from "./pie-chart-wrapper";
  import PieChart from "./pie-chart";

  export default {
      name: "chart-overview-vserver",
    components: {PieChart, PieChartWrapper},
    props:{
        datasetA:String,
        datasetB:String,
        category:String,
        options:String,
        backgroundColor:Array,
        label:Array
    },
    data:()=>({

        time:null,
        cf:'AVERAGE',
        timelines:{
          live:'Live',
          hour:'Stunde',
          day:'Tag',
          week:'Woche',
          month:'Monat',
          year:'Jahr'
        }
      }),
      created(){
        //if(!this.time) this.time = 'hour'
      },

      computed:{
        modelKeyC(){
              //return this.vid+'_'+this.time+'_'+this.cf
            return this.vid
          },
        labelC(){
          return this.label
        },
        catKey(){
          return this.timelines[this.time] || undefined
        },
        chartData(){
          return {
            labels:this.labelC || this.label,
            datasets:[
              {
                backgroundColor:this.backgroundColor || '',
                data:[
                  //this.modelC[this.datasetA].length ? this.modelC[this.datasetA].reduce((sum, x) => sum + x) : 0 ,
                  //this.modelC[this.datasetB].length ? this.modelC[this.datasetB].reduce((sum, x) => sum + x) : 0 ,
                    this.modelC[this.datasetA],
                    this.modelC[this.datasetB],
                ]
              }
            ]
          } || undefined
        },
        /*modelC(){
          if(!this.time) this.time = 'hour'
          if(!VserverGraph.find(this.modelKeyC)) this.getG()
          return VserverGraph.find(this.modelKeyC) || undefined
        },*/
        modelC(){
              if(!this.time) this.time = 'hour'
              if(!Vserver.find(this.modelKeyC)) this.getG()
              return Vserver.find(this.modelKeyC).status || undefined
          },

        vid(){
          return this.$route.params.id || undefined
        },
        optionsC(){
          return ChartOptions[this.options] || ChartOptions['memPie']
        },
      },
    methods:{
      getG(){
        //if(this.time === 'live') {this.timer = setInterval(this.getG(), 4000)}
        //if(this.time !== 'live') {clearInterval(this.timer)}
        /*if(this.time === 'live') {
          const t = Date.now()
          this.label.push(this.$moment(t).format('hh:mm:ss'))
        }*/
        //VserverGraph.getGraph(this.vid, this.cf, this.time)
          Vserver.fetchStatus(this.vid)
      }
    }

    }
</script>

<style scoped>
  .timelink{
    width: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/chart-overview-vserver.vue